export const TOP = '/'
export const STORIES = '/stories'
export const STORIES_NEW = `${STORIES}/?order=new`
export const STORIES_POPULAR = `${STORIES}/?order=rank`
export const STORIES_FEATURE = `${STORIES}/?order=feature`
export const COMPANY = '/pages/company_new'
export const TERMS = '/terms'
export const PRIVACY = '/privacy'
export const SECURITY = '/pages/secuity'
export const ARTICLES = '/articles'

export const FEEDBACKS = '/companies/feedbacks'

export const MESSAGES = '/companies/messages'

export const NEEDS = '/companies/needs'
export const RECOMMEND = '/companies/recommend'
export const REQUEST_BOX = '/companies/request_boxes'
export const NOTICES = '/companies/articles'

export const EDIT = '/companies/edit'
export const EDIT_STORYLIST = '/companies/edit-storylist'
export const EDIT_STORY = '/companies/edit-storylist/edit-story'
export const EDIT_FIXED_MESSAGE = '/user_fixed_message'
export const EDIT_PERSONA = '/company_personas'
export const NOTICE_CONFIGURATION = '/companies/notice-configuration'

export const CONTACT = '/contacts/new'

export const REFERRER_MESSAGE_GROUP = '/companies/message_group_index'

export const membersArticlePage = (id: number) => `/companies/articles/${id}`

export const REPORT_PURCHASE = '/companies/purchases/new'
